import { useRouter } from 'next/router';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { isPhoneVerificationPromptRouteEligible } from '@/shared/features/phone-verification/utils';
import { usePhoneVerificationBannerModal } from '../hooks';

/** 인증 유도 배너 모달의 마운트 지점. 가입 직후는 `SignUpAction` 이 인증 페이지로 직행시킨다. */
export const PhoneVerificationBannerModalGate = () => {
  const router = useRouter();
  const isInExternalPlatform = useIsInExternalPlatform();
  const isEnabled = isPhoneVerificationPromptRouteEligible({
    isInExternalPlatform,
    pathname: router.pathname
  });
  usePhoneVerificationBannerModal({
    enabled: isEnabled
  });
  return null;
};